import { lazy } from "react";
import { Route } from "react-router-dom";
import { AppRoutes } from "@/infra/router";
import LazyPage from "@/infra/router/LazyPage";

const TermsAndConditionsPage = lazy(() => import("@/pages/legal/TermsAndConditionsPage"));
const PrivacyPolicyAndDataTransparencyPage = lazy(() => import("@/pages/legal/PrivacyPolicyAndDataTransparencyPage"));
const IFUPage = lazy(() => import("@/pages/legal/IFUPage"));

export const legalRoutes = [
  <Route
    key={AppRoutes.TermsAndConditions}
    element={<LazyPage element={<TermsAndConditionsPage />} />}
    path={AppRoutes.TermsAndConditions}
  />,
  <Route
    key={AppRoutes.PrivacyPolicyAndDataTransparency}
    element={<LazyPage element={<PrivacyPolicyAndDataTransparencyPage />} />}
    path={AppRoutes.PrivacyPolicyAndDataTransparency}
  />,
  <Route key={AppRoutes.IFU} element={<LazyPage element={<IFUPage />} />} path={AppRoutes.IFU} />,
];
